export const textTermsOfUse = [
  {
    textHead: "1. Introduction",
    textBody: `Welcome to flappybee.com ("Website") and the associated web3 game available at app.flappybee.com ("Game"). These Terms of Service ("Terms") govern your use of our services. By accessing or using our services, you agree to be bound by these Terms. If you do not agree to these Terms, please do not use our services.`,
  },
  {
    textHead: "2. Utility Token (BEET Token)",
    textBody:
      "Our services may involve the use of a utility token known as BEET Token. These tokens are provided for specific purposes within our ecosystem and are not intended for speculative investment. By using our services, you acknowledge and agree that BEET Tokens are utility tokens and do not represent any form of ownership, equity, or security.",
  },
  {
    textHead: "3. Eligibility",
    textBody:
      "Our services are not intended for players who are residents of the United States. By using our services, you affirm that you are not a resident of the United States and that you are eligible to use our services under applicable laws and regulations.",
  },
  {
    textHead: "4. Play at Your Own Risk",
    textBody:
      'You acknowledge and understand that using our services, including participating in the Game and using BEET Tokens, involves inherent risks. You agree to use our services at your own risk, and you acknowledge that the services are provided "as is" without any warranties or guarantees.',
  },
  {
    textHead: '5. "As-Is" Service',
    textBody:
      'Our services are provided on an "as-is" basis, and we make no representations or warranties, express or implied, regarding the accuracy, reliability, or functionality of our services. We do not guarantee uninterrupted access to our services, and we reserve the right to modify or discontinue our services at any time without notice.',
  },
  {
    textHead: "6. Hacks and Technical Issues",
    textBody:
      "While we take measures to maintain the security and functionality of our services, we cannot guarantee that our services will be free from hacks or technical issues. You acknowledge that we are not responsible for any hacks or technical issues that may affect your use of our services.",
  },
  {
    textHead: '7. "FREE MINT" Event',
    textBody:
      'We may offer a "FREE MINT" event during which users can play the Game to earn BEET Tokens. Participation in this event is subject to additional terms and conditions that will be provided separately. By participating in the "FREE MINT" event, you agree to comply with these additional terms and conditions.',
  },
  {
    textHead: "8. Prohibited Activities",
    textBody:
      "You agree not to abuse our services, engage in fraudulent activities, or violate any applicable laws or regulations while using our services. We reserve the right to take appropriate actions, including but not limited to suspending or terminating your access, if we suspect any such prohibited activities.",
  },
  {
    textHead: "9. Child Protection",
    textBody:
      "Protecting the privacy and safety of children is important to us. If you are under the age of 18, you may only use our services with the consent and supervision of a parent or guardian. We do not knowingly collect personal information from children under 13 years of age.",
  },
  {
    textHead: "10. Changes to Terms",
    textBody:
      "We reserve the right to update or modify these Terms at any time without prior notice. Your continued use of our services after such changes constitutes your acceptance of the revised Terms. We recommend reviewing these Terms regularly for any updates.",
  },
  {
    textHead: "11. Contact Us",
    textBody:
      "If you have any questions or concerns regarding these Terms of Service, please contact us at tos@flappybee.com",
  },
];
